import { defineComponent, computed, createElementBlock, openBlock, normalizeClass, createElementVNode, normalizeStyle, Fragment, renderList, createBlock, createCommentVNode, toDisplayString } from 'vue';
import _sfc_main$1 from './basler-components.es81.js';
/* empty css                       */

const _hoisted_1 = ["aria-label"];
const _hoisted_2 = ["aria-selected", "onClick"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SegmentControls",
  props: {
    controls: {},
    displayStyle: {},
    ariaLabel: {}
  },
  emits: ["change"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const activeControlIndex = computed(() => {
      const activeIndex = props.controls.findIndex((btn) => btn.isActive);
      if (activeIndex === -1) {
        return 0;
      } else {
        return activeIndex;
      }
    });
    const onClick = (btnClicked) => {
      props.controls.forEach((controlBtn) => {
        if (controlBtn === btnClicked) {
          btnClicked.isActive = true;
        } else {
          controlBtn.isActive = false;
        }
      });
      emit("change", btnClicked);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["segment-controls", { "is-secondary": _ctx.displayStyle && _ctx.displayStyle === "secondary" }])
      }, [
        createElementVNode("div", {
          role: "tablist",
          class: "segment-controls__container",
          "aria-label": _ctx.ariaLabel,
          style: normalizeStyle(`--active-control-index: ${activeControlIndex.value}`)
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.controls, (control) => {
            return openBlock(), createElementBlock("button", {
              key: control.title,
              type: "button",
              role: "tab",
              "aria-selected": control.isActive,
              class: normalizeClass(["segment-controls__btn", { "is-active": control.isActive }]),
              onClick: ($event) => onClick(control)
            }, [
              control.iconName ? (openBlock(), createBlock(_sfc_main$1, {
                key: 0,
                name: control.iconName
              }, null, 8, ["name"])) : createCommentVNode("", true),
              createElementVNode("span", null, toDisplayString(control.title), 1)
            ], 10, _hoisted_2);
          }), 128))
        ], 12, _hoisted_1)
      ], 2);
    };
  }
});

export { _sfc_main as default };
